import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import GallerySection from '../components/GallerySection'
import { imageUrl } from '../lib/images'

// Gris-ikon til FAQ-sektion
function PigIcon({ className = "w-40 h-28 text-[#C25E27]" }) {
  return (
    <svg
      viewBox="0 0 120 76"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      {/* Krøllet hale */}
      <path
        d="M17 38 C10 33, 7 24, 13 19 C19 15, 26 20, 23 26 C21 29, 16 30, 15 27"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* Pattegris krop */}
      <path
        d="M20 40 
           C20 25, 33 16, 54 16 
           C72 16, 85 22, 95 28 
           L103 18 
           C105 16.5, 107 18, 106 21 
           L103 30 
           C111 34, 117 38, 118 44 
           C118.5 48, 116 50, 111 50 
           L108 50 
           C106 57, 98 63, 89 63 
           L86 70 
           C85.5 71.5, 82.5 71.5, 82 70 
           L79 63 
           C71 63.5, 59 63.5, 52 63 
           L49 70 
           C48.5 71.5, 45.5 71.5, 45 70 
           L42 62.5 
           C32 62, 20 54, 20 40 Z"
      />
      {/* Øje */}
      <circle cx="97" cy="34" r="2.8" fill="#241F1C" />
      {/* Næsebor/tryne markering */}
      <ellipse cx="112" cy="45" rx="2.5" ry="3.8" fill="#241F1C" opacity="0.35" />
    </svg>
  )
}

export default function Home() {
  const [openFaq, setOpenFaq] = useState(null)
  const [testimonialIndex, setTestimonialIndex] = useState(0)

  const testimonials = [
    {
      name: 'Anders Sørensen',
      occasion: 'Fødselsdagsfest',
      text: '"Vi fik helstegt pattegris til vores havefest, og vi kunne ikke have været mere tilfredse! Kødet var fantastisk mørt, sværen sprød som glas og salatbuffeten var frisk og lækker. Top professionelt personale!"',
    },
    {
      name: 'Mette & Lars',
      occasion: 'Konfirmation',
      text: '"Tusind tak for super god mad og service til vores konfirmation. Grisen blev skåret ud foran gæsterne, og alle roste maden til skyerne. Der var rigeligt med mad, og alt kom lige til tiden."',
    },
    {
      name: 'Jesper K.',
      occasion: 'Firmafest',
      text: '"Vi brugte Overgaard Pattegrise til vores årlige sommerfest i firmaet med 85 personer. Klar anbefaling herfra – nem kommunikation, punktlighed og mad i særklasse!"',
    },
    {
      name: 'Helle & Christian',
      occasion: 'Sølvbryllup',
      text: '"Helt igennem sublim oplevelse! Grillmesteren var venlig, punktlig og underholdende, og gæsterne taler stadig om de sprøde svær og det saftige kød."',
    },
    {
      name: 'Brian Mikkelsen',
      occasion: 'Gadefest',
      text: '"Perfekt arrangement til vores gadefest. Fantastisk nemt for os som værter, og maden var helt i top. Vi booker helt sikkert igen til næste år."',
    },
  ]

  const nextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length)
  }

  const prevTestimonial = () => {
    setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)
  }

  const faqs = [
    {
      q: 'Hvornår skal I endeligt vide antal af gæster og valg af menu?',
      a: 'Endeligt antal og valg af menu skal vi vide senest 14 dage før levering.',
    },
    {
      q: 'Hvornår og hvordan betaler jeg?',
      a: 'Vi sender en faktura forud for levering. Betaling sker nemt via bankoverførsel.',
    },
    {
      q: 'Kan vi bestille grillgris, selvom vi er færre end 45 personer?',
      a: 'Ja, I betaler blot for grisen til minimum 45 personer, eller I kan vælge vores populære stegebuffeter fra 25 personer.',
    },
    {
      q: 'Hvad kræver det at grille en pattegris hos os?',
      a: 'I tilfælde af dårligt vejr skal grillen kunne stå i tørvejr f.eks. pavillon, garage eller carport. Der skal kunne køres til afleveringsstedet, og der skal bruges et bord til udskæring.',
    },
    {
      q: 'Hvor længe skal pattegrisen grilles?',
      a: 'Afhængigt af grisens størrelse skal den have mellem 5-7 timer. Vores grillmester kommer derfor 5-7 timer før spisetid og tænder op, så kødet er mørt og sværen sprød til tiden.',
    },
    {
      q: 'Hvor leverer Overgaard Pattegrise?',
      a: 'Vi har base i Sønder Omme og leverer catering og helstegt pattegris i hele lokalområdet, Grindsted, Billund og det midt- og vestjyske.',
    },
  ]

  const toggleFaq = (idx) => {
    setOpenFaq(openFaq === idx ? null : idx)
  }

  return (
    <div>
      {/* HERO SECTION */}
      <section className="relative overflow-hidden bg-[#2D2622] text-white">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={imageUrl('/_assets/img-4538.jpeg', 'width=1800,quality=80,format=auto')}
            alt="Helstegt pattegris på grill med sprød svær og saftigt kød"
            className="w-full h-full object-cover opacity-60 hero-zoom-img"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#241F1C]/80 via-[#241F1C]/45 to-transparent" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-28 sm:py-36 lg:py-44">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
              Helstegt pattegris &amp; festcatering i særklasse
            </h1>

            <p className="mt-5 text-base sm:text-lg lg:text-xl text-[#f1f1f1] leading-relaxed mx-auto max-w-xl">
              Mør grillgris med sprøde svær, erfaren grillmester og frisklavet tilbehør til din fest.
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2.5 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-3 sm:px-8 sm:py-4 font-bold text-sm sm:text-base transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <i className="fa-solid fa-utensils text-sm" aria-hidden="true" />
                <span>Sammensæt menu</span>
              </Link>

              <a
                href="tel:25752724"
                className="inline-flex items-center gap-2 bg-transparent text-white border-2 border-white px-5 py-3 sm:px-7 sm:py-4 font-semibold text-sm sm:text-base transition-colors hover:bg-transparent cta-hop"
              >
                <i className="fa-solid fa-phone text-sm" aria-hidden="true" />
                <span className="whitespace-nowrap">25 75 27 24</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CORE OFFERINGS (3 Cards) */}
      <section className="bg-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#241F1C]">
              Smagfuld mad til enhver festlig anledning
            </h2>
            <p className="mt-3 text-[#6E635C] text-sm sm:text-base leading-relaxed">
              Fra klassisk helstegt pattegris med sprød svær til komplette stegebuffeter med oksefilet,
              porchetta og friske salater.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-white border border-[#E6DFD5] flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl">
              <div>
                <div className="relative aspect-[16/10] overflow-hidden bg-[#E6DFD5]">
                  <img
                    src={imageUrl('/_assets/img-4538.jpeg', 'width=600,quality=80,format=auto')}
                    alt="Helstegt pattegris"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#241F1C]">Helstegt pattegris</h3>
                  <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                    Mør grillgris tilberedt på stedet med sprøde svær af vores erfarne grillmester.
                  </p>
                </div>
              </div>
              <div className="p-6 pt-0">
                <Link
                  to="/helstegt-pattegris"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#241F1C] hover:text-black"
                >
                  <span>Læs mere om helstegt pattegris</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white border border-[#E6DFD5] flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl">
              <div>
                <div className="aspect-[16/10] overflow-hidden bg-[#E6DFD5]">
                  <img
                    src={imageUrl('/_assets/img-4537.jpeg', 'width=600,quality=80,format=auto')}
                    alt="Grill Catering"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#241F1C]">Grill catering</h3>
                  <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                    Komplette cateringløsninger tilpasset bryllup, konfirmation, fødselsdag og firmafest.
                  </p>
                </div>
              </div>
              <div className="p-6 pt-0">
                <Link
                  to="/catering"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#241F1C] hover:text-black"
                >
                  <span>Læs mere om catering</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white border border-[#E6DFD5] flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl md:col-span-2 lg:col-span-1">
              <div>
                <div className="aspect-[16/10] overflow-hidden bg-[#E6DFD5]">
                  <img
                    src={imageUrl('/_assets/img-4783.jpeg', 'width=600,quality=80,format=auto')}
                    alt="Mad ud af huset"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#241F1C]">Mad ud af huset</h3>
                  <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                    Festbuffeter med 1, 2 eller 3 slags kød, frisklavede kartofler, lune saucer og friske salater.
                  </p>
                </div>
              </div>
              <div className="p-6 pt-0">
                <Link
                  to="/mad-ud-af-huset"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#241F1C] hover:text-black"
                >
                  <span>Læs mere om mad ud af huset</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEST OG UDLEJNING PROMO SECTION */}
      <section className="bg-[#FAF8F5] py-16 sm:py-20 border-y border-[#E6DFD5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6 space-y-5">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#241F1C] tracking-tight">
                Fest &amp; udlejning
              </h2>
              <p className="text-sm sm:text-base text-[#6E635C] leading-relaxed">
                Skal havefesten, fødselsdagen eller firmafesten have et ekstra pift? Ud over saftig pattegris og catering udlejer vi også professionelt festudstyr til Danmarks skarpeste priser:
              </p>
              <div className="grid grid-cols-2 gap-3 text-xs sm:text-sm text-[#241F1C]">
                <div className="flex items-center gap-2 p-2.5 bg-white border border-[#E6DFD5]">
                  <i className="fa-solid fa-ice-cream text-[#C25E27]" aria-hidden="true" />
                  <span><strong>Softicemaskine</strong> (1.250 kr.)</span>
                </div>
                <div className="flex items-center gap-2 p-2.5 bg-white border border-[#E6DFD5]">
                  <i className="fa-solid fa-glass-water-droplet text-[#C25E27]" aria-hidden="true" />
                  <span><strong>Slushicemaskine</strong> (625 kr.)</span>
                </div>
                <div className="flex items-center gap-2 p-2.5 bg-white border border-[#E6DFD5]">
                  <i className="fa-solid fa-shield-cat text-[#C25E27]" aria-hidden="true" />
                  <span><strong>Hoppeborg</strong> (1.500 kr.)</span>
                </div>
                <div className="flex items-center gap-2 p-2.5 bg-white border border-[#E6DFD5]">
                  <i className="fa-solid fa-hat-cowboy text-[#C25E27]" aria-hidden="true" />
                  <span><strong>Rodeo Tyr</strong> (3.500 kr.)</span>
                </div>
              </div>
              <p className="text-xs text-[#8C827A]">
                * Priserne gælder ved afhentning i Sønder Omme. Levering og opsætning tilbydes mod mindre tillæg.
              </p>
              <div className="pt-2">
                <Link
                  to="/fest-og-udlejning"
                  className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-6 py-3 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
                >
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  <span>Se udstyr, priser &amp; beregner</span>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="aspect-square overflow-hidden bg-white border border-[#E6DFD5] shadow-sm">
                  <img
                    src={imageUrl('/_assets/softicemaskine-professionel-festudlejning.jpg', 'width=500,quality=80,format=auto')}
                    alt="Softicemaskine udlejning"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="aspect-square overflow-hidden bg-white border border-[#E6DFD5] shadow-sm">
                  <img
                    src="https://assets.auxodev.dk/assets/5d78d207-d7b4-4866-8f75-23fa665241c8/image_d0ab64d8.png"
                    alt="Slushicemaskine udlejning"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="aspect-square overflow-hidden bg-white border border-[#E6DFD5] shadow-sm">
                  <img
                    src={imageUrl('https://assets.auxodev.dk/assets/5d78d207-d7b4-4866-8f75-23fa665241c8/image_00a53d99.png', 'width=500,quality=80,format=auto')}
                    alt="Hoppeborg udlejning"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="aspect-square overflow-hidden bg-white border border-[#E6DFD5] shadow-sm">
                  <img
                    src={imageUrl('/_assets/image_a87f573e.png', 'width=500,quality=80,format=auto')}
                    alt="Rodeo tyr udlejning"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS / STEPS */}
      <section className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#241F1C]">
              Fra menuvalg til vellykket havefest
            </h2>
            <p className="mt-3 text-[#6E635C] text-sm sm:text-base leading-relaxed">
              En aftale er en aftale hos Overgaard Pattegrise. Vi tager ansvar for hele madoplevelsen fra start til slut.
            </p>
          </div>

          {/* Process Timeline Flow */}
          <div className="relative">
            {/* Horizontal line for desktop */}
            <div className="hidden lg:block absolute top-7 left-12 right-12 h-[2px] bg-[#E6DFD5] -z-0" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-8 relative z-10">
              {/* Step 1 */}
              <div className="flex flex-col items-start sm:items-center lg:items-start text-left sm:text-center lg:text-left">
                <div className="w-14 h-14 bg-white border-2 border-[#241F1C] text-[#241F1C] font-black text-xl flex items-center justify-center mb-6 shadow-sm">
                  01
                </div>
                <h3 className="font-bold text-lg text-[#241F1C] tracking-tight">Sammensæt din menu</h3>
                <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                  Brug vores online bestillingsguide til nemt at vælge forret, kødtyper, kartofler, saucer og salater.
                </p>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col items-start sm:items-center lg:items-start text-left sm:text-center lg:text-left">
                <div className="w-14 h-14 bg-white border-2 border-[#241F1C] text-[#241F1C] font-black text-xl flex items-center justify-center mb-6 shadow-sm">
                  02
                </div>
                <h3 className="font-bold text-lg text-[#241F1C] tracking-tight">Vi bekræfter aftalen</h3>
                <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                  Vi gennemgår dine ønsker sammen og fastlægger tidspunkter, kuvertantal og alle praktiske detaljer.
                </p>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col items-start sm:items-center lg:items-start text-left sm:text-center lg:text-left">
                <div className="w-14 h-14 bg-white border-2 border-[#241F1C] text-[#241F1C] font-black text-xl flex items-center justify-center mb-6 shadow-sm">
                  03
                </div>
                <h3 className="font-bold text-lg text-[#241F1C] tracking-tight">Grillmester møder op</h3>
                <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                  Grillmesteren ankommer 5-7 timer før spisetid og tænder op, så kødet grilles langsomt og saftigt.
                </p>
              </div>

              {/* Step 4 */}
              <div className="flex flex-col items-start sm:items-center lg:items-start text-left sm:text-center lg:text-left">
                <div className="w-14 h-14 bg-white border-2 border-[#241F1C] text-[#241F1C] font-black text-xl flex items-center justify-center mb-6 shadow-sm">
                  04
                </div>
                <h3 className="font-bold text-lg text-[#241F1C] tracking-tight">Udskæring &amp; servering</h3>
                <p className="text-sm text-[#6E635C] mt-2 leading-relaxed">
                  Maden skæres for direkte ved buffeten, sprøde svær fordeles, og du og dine gæster kan bare nyde festen.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-14">
            <Link
              to="/bestil"
              className="inline-flex items-center gap-2.5 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-3 sm:px-8 sm:py-4 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
            >
              <i className="fa-solid fa-utensils text-xs" aria-hidden="true" />
              <span>Gå til menu- og bestillingsguiden</span>
            </Link>
          </div>
        </div>
      </section>

      {/* GALLERI SECTION (from CMS) */}
      <GallerySection
        gallerySlug="helstegt-pattegris-galleri"
        title="Glimt fra vores arrangementer"
        subtitle="Se stemningen, grillningen og buffeterne fra vores selskaber i lokalområdet."
      />

      {/* FAQ SECTION - Mindre sektion med FAQ i den ene side og ikon af gris i højre side */}
      <section className="bg-[#241F1C] text-white py-10 sm:py-14 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            {/* FAQ I DEN ENE SIDE */}
            <div className="lg:col-span-7 xl:col-span-8">
              <div className="mb-6 sm:mb-8">
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-extrabold text-white">
                  Ofte stillede spørgsmål
                </h2>
                <p className="mt-2 text-xs sm:text-sm text-[#DDD5C9]">
                  Få hurtigt svar på de mest almindelige spørgsmål om bestilling, levering og grillning.
                </p>
              </div>

              <div className="space-y-3">
                {faqs.map((faq, idx) => {
                  const isOpen = openFaq === idx
                  return (
                    <div
                      key={idx}
                      className="bg-[#2D2723] border border-white/10 overflow-hidden transition-all duration-300 hover:border-white/20 hover:shadow-md"
                    >
                      <button
                        type="button"
                        onClick={() => toggleFaq(idx)}
                        className="w-full text-left px-5 py-3.5 sm:py-4 flex items-center justify-between gap-4 font-bold text-sm sm:text-base text-white cursor-pointer"
                        aria-expanded={isOpen}
                      >
                        <span>{faq.q}</span>
                        <i
                          className={`fa-solid fa-chevron-down text-xs text-[#C25E27] transition-transform duration-200 flex-shrink-0 ${
                            isOpen ? 'rotate-180' : ''
                          }`}
                          aria-hidden="true"
                        />
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-4 text-xs sm:text-sm text-[#DDD5C9] leading-relaxed border-t border-white/10 pt-3">
                          {faq.a}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>

            {/* IKON AF EN GRIS I HØJRE SIDE */}
            <div className="lg:col-span-5 xl:col-span-4 flex items-center justify-center py-4 lg:py-0">
              <div className="flex flex-col items-center justify-center text-center">
                <PigIcon className="w-40 h-28 sm:w-56 sm:h-38 lg:w-64 lg:h-44 text-[#C25E27] transition-transform duration-300 hover:scale-105" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CUSTOMER REVIEWS */}
      <section className="bg-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-12">
            <div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#241F1C]">
                Hvad siger vores gæster?
              </h2>
              <p className="mt-3 text-[#6E635C] text-sm sm:text-base leading-relaxed">
                Vi samler på tilfredse gæster med mætte maver og gode minder.
              </p>
            </div>
            {/* Navigation arrows */}
            <div className="flex items-center gap-3 mt-6 sm:mt-0">
              <button
                type="button"
                onClick={prevTestimonial}
                aria-label="Forrige anmeldelse"
                className="w-10 h-10 text-xl text-[#241F1C] hover:text-[#C25E27] flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-arrow-left" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={nextTestimonial}
                aria-label="Næste anmeldelse"
                className="w-10 h-10 text-xl text-[#241F1C] hover:text-[#C25E27] flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[0, 1, 2].map((offset) => {
              const item = testimonials[(testimonialIndex + offset) % testimonials.length]
              return (
                <div
                  key={`${item.name}-${offset}`}
                  className="bg-white p-6 sm:p-8 shadow-md flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl"
                >
                  <div>
                    <div className="flex items-center gap-1 text-[#C25E27] text-sm mb-4">
                      <i className="fa-solid fa-star" aria-hidden="true" />
                      <i className="fa-solid fa-star" aria-hidden="true" />
                      <i className="fa-solid fa-star" aria-hidden="true" />
                      <i className="fa-solid fa-star" aria-hidden="true" />
                      <i className="fa-solid fa-star" aria-hidden="true" />
                    </div>
                    <p className="text-sm text-[#241F1C] leading-relaxed italic">
                      {item.text}
                    </p>
                  </div>
                  <div className="mt-6 pt-4 border-t border-[#E6DFD5]/40 text-xs">
                    <span className="font-bold text-[#241F1C] block">{item.name}</span>
                    <span className="text-[#6E635C]">{item.occasion}</span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* OM OS SEKTION PÅ FORSIDEN */}
      <section className="bg-white py-16 sm:py-24 border-t border-[#E6DFD5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="relative lg:min-h-[580px] flex flex-col lg:flex-row items-center">
            {/* Stort billede - til venstre */}
            <div className="w-full lg:w-8/12 lg:mr-auto h-[360px] sm:h-[460px] lg:h-[580px] overflow-hidden shadow-lg">
              <img
                src={imageUrl('/_assets/img-4536.jpeg', 'width=1400,quality=80,format=auto')}
                alt="Grillmesteren og helstegt pattegris hos Overgaard Pattegrise"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Tekstboks der går ind over billedet - til højre */}
            <div className="relative z-10 w-full sm:w-[92%] lg:w-6/12 -mt-16 sm:-mt-20 lg:mt-0 lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 bg-white p-6 sm:p-10 lg:p-12 shadow-2xl border border-[#E6DFD5]">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#241F1C] tracking-tight leading-tight">
                Om Overgaard Pattegrise – Passion for god mad og uforglemmelige selskaber
              </h2>
              <p className="mt-5 text-sm sm:text-base text-[#6E635C] leading-relaxed">
                Hos Overgaard Pattegrise sætter vi pris på godt håndværk og bruger råvarer af høj kvalitet –
                og det kan altså smages! Vi leverer grillmad og catering til både små og store selskaber
                i Sønder Omme og hele Jylland.
              </p>
              <p className="mt-4 text-sm sm:text-base text-[#6E635C] leading-relaxed">
                Vi ved, at vi er med til at sætte rammen for dit arrangement – og det ansvar bærer vi med glæde.
                Derfor møder vi altid op med et smil og bidrager til en god, afslappet stemning til din fest.
              </p>

              <div className="mt-8 flex flex-wrap gap-3 sm:gap-4">
                <Link
                  to="/om-os"
                  className="inline-flex items-center gap-2 bg-[#241F1C] hover:bg-black text-white px-5 py-3 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg"
                >
                  <span>Læs mere om os</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
                <Link
                  to="/bestil"
                  className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-3 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
                >
                  <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
                  <span>Sammensæt menu</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GOOGLE MAPS I SORT/HVID */}
      <section className="relative w-full h-72 sm:h-96 bg-[#241F1C] overflow-hidden" aria-label="Find Overgaard Pattegrise">
        <iframe
          title="Kort over Overgaard Pattegrise – Simmelbrovej 52, 7260 Sønder Omme"
          src="https://maps.google.com/maps?q=Simmelbrovej%2052,%207260%20S%C3%B8nder%20Omme&t=&z=14&ie=UTF8&iwloc=&output=embed"
          className="w-full h-full border-0 filter grayscale contrast-125 brightness-95"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        {/* Adressebadge på maps */}
        <div className="absolute top-4 left-4 sm:top-6 sm:left-6 z-10 bg-white/95 backdrop-blur-sm p-4 sm:p-5 shadow-xl border border-[#E6DFD5] max-w-xs sm:max-w-sm">
          <div className="flex items-start gap-3">
            <i className="fa-solid fa-location-dot text-[#C25E27] text-lg mt-0.5" aria-hidden="true" />
            <div>
              <p className="font-bold text-sm text-[#241F1C]">Overgaard Pattegrise</p>
              <p className="text-xs text-[#6E635C] mt-0.5">Simmelbrovej 52, 7260 Sønder Omme</p>
              <a
                href="https://maps.google.com/?q=Simmelbrovej+52,+7260+Sønder+Omme"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#C25E27] hover:text-[#A84E1C] mt-2"
              >
                <span>Find vej på Google Maps</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
